import { postJson } from '../utils/api-utils';

type MfaStatusResponse = {
  mfaComplete: boolean;
  hasPhoneNumber: boolean;
  hasEmail: boolean;
  isAccountVerified: boolean;
};

const fetchMfaStatus = async (apiUrl: string, signal?: AbortSignal): Promise<MfaStatusResponse> => {
  const response = await fetch(`${apiUrl}/auth/mfa/status`, {
    credentials: 'include',
    method: 'GET',
    signal,
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  const payload = await response.json().catch(() => null);
  if (!payload || typeof payload.mfaComplete !== 'boolean') {
    throw new Error(`Invalid MFA status response: ${response.status}`);
  }

  return payload;
};

const resendMfaCode = async (apiUrl: string): Promise<void> => {
  await postJson(`${apiUrl}/auth/mfa/phone/resend`, {});
};

const requestMfaCode = async (apiUrl: string, phoneNumber: string): Promise<void> => {
  await postJson(`${apiUrl}/auth/mfa/phone/request`, { phoneNumber });
};

const confirmMfaCode = async (apiUrl: string, code: string): Promise<void> => {
  await postJson(`${apiUrl}/auth/mfa/phone/confirm`, { code });
};

export { confirmMfaCode, fetchMfaStatus, requestMfaCode, resendMfaCode };
export type { MfaStatusResponse };
